import { getCustomColumnValues } from "views/Findings/utils";

export function resolveCustomColumnValues<
  T extends { tags?: string[] | string; tagList?: string[] | string },
>(
  record: T,
  columnKey: string,
  keyName: "tags" | "tagList" = "tags",
  ignoreCase = false,
): string[] {
  const tagField = record?.[keyName];
  const tags =
    tagField && typeof tagField === "string" ? JSON.parse(tagField) : tagField;
  return getCustomColumnValues(tags, columnKey, ignoreCase);
}
